import { render, staticRenderFns } from "./tableColumn.vue?vue&type=template&id=20303110&scoped=true&"
import script from "./tableColumn.vue?vue&type=script&lang=js&"
export * from "./tableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20303110",
  null
  
)

export default component.exports